import * as Cesium from "cesium";

// helper: store original style once and apply highlight color
export function highlightEntityForSelection(entity, color = Cesium.Color.RED) {
  if (!entity) return;

  // save original style once
  if (!entity._originalStyle) {
    entity._originalStyle = {
      polygonMaterial: entity.polygon ? entity.polygon.material : undefined,
      polylineMaterial: entity.polyline ? entity.polyline.material : undefined,
      polylineWidth: entity.polyline ? entity.polyline.width : undefined,
    };
  }

  // apply highlight color
  if (entity.polygon) {
    entity.polygon.material = color;
  }

  if (entity.polyline) {
    entity.polyline.material = color;
  }
}

// call this once after viewer is ready
export function initShiftClickSelect(viewer, selectedEntitiesRef, editModeRef, setSelectedEntities) {
  const handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);

  // Shift + Click => select / make highlighted
  handler.setInputAction(
    function (movement) {
      if (editModeRef?.current) return;

      const picked = viewer.scene.pick(movement.position);
      if (!picked || !picked.id) return;

      const entity = picked.id;

      const current = selectedEntitiesRef.current || [];

      const alreadySelected = current.some(function (e) {
        return e.id === entity.id;
      });

      if (alreadySelected) return;

      // use shared highlight helper
      highlightEntityForSelection(entity);

      const next = [...current, entity]; // new array
      selectedEntitiesRef.current = next; // keep ref in sync for utilities
      setSelectedEntities(next); // update React state
    },
    Cesium.ScreenSpaceEventType.LEFT_CLICK,
    Cesium.KeyboardEventModifier.SHIFT,
  );

  return function destroyShiftClickSelect() {
    handler.destroy();
  };
}
